import { render, staticRenderFns } from "./AbstractNotificationDetail.vue?vue&type=template&id=da083720&"
import script from "./AbstractNotificationDetail.vue?vue&type=script&lang=js&"
export * from "./AbstractNotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./AbstractNotificationDetail.vue?vue&type=style&index=0&id=da083720&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports